var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
import PrimaryButton from "../Button/PrimaryButton";
import useFetchUserProfile from "../../hooks/useFetchUserProfile";
import Spinner from "../Spinner";
import useUpdateProfile from "../../hooks/useUpdateProfile";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import images from "../../utils/Images";
var EditProfileModal = function (_a) {
    var closeModal = _a.closeModal, saveProfileHandle = _a.saveProfileHandle;
    var _b = useFetchUserProfile(), userProfile = _b.userProfile, loading = _b.loading;
    var userId = useSelector(function (state) { return state.user.userId; });
    var _c = React.useState(''), seniority = _c[0], setSeniority = _c[1];
    var _d = useUpdateProfile(), updateProfile = _d.updateProfile, isSaving = _d.loading, error = _d.error, success = _d.success;
    useEffect(function () {
        if (userProfile) {
            setSeniority(userProfile.seniority || '');
        }
    }, [userProfile]);
    var closeModalHandle = function () {
        closeModal();
    };
    var updateHandle = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateProfile({ seniority: seniority, id: userId })];
                case 1:
                    _a.sent();
                    saveProfileHandle(error);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: " absolute flex-1 bottom-10 right-0 left-0 z-10 justify-center px-4 modal-popup", children: [loading &&
                _jsx("div", { className: "flex justify-center items-center h-[300px]", children: _jsx(Spinner, { size: 160 }) }), !loading && userProfile &&
                _jsxs("div", { className: "bg-white my-12 relative w-full rounded-xl border-[#00000014] outline-none p-4 opacity-100", children: [_jsx("button", { onClick: function () { return closeModalHandle(); }, className: "absolute top-[-22px] right-[2px]", children: _jsx("img", { src: images.closeIcon, alt: "", style: { height: '50px' } }) }), _jsx("div", { className: "mt-2", children: _jsx("h3", { className: "blue-text-color text-center text-[18px]", children: "Edit Profile" }) }), _jsxs("div", { className: "my-4 ", children: [_jsx("label", { htmlFor: "phone-number", className: "mb-3 text-[15px] font-[500]", children: "What would your Seniority be in January?" }), _jsx("div", { className: "mt-2", children: _jsx("input", { type: "number", inputMode: "numeric", pattern: "[0-9]*", className: "mt-[10px] w-full border borde-[#00000014] outline-none px-3 py-1 rounded-md form-control", placeholder: "Seniority (number of years)", value: seniority, onChange: function (e) {
                                            var raw = e.target.value;
                                            var cleaned = raw.replace(/\D+/g, ''); // strip non-digits (no decimals)
                                            if (cleaned === '') {
                                                setSeniority('');
                                                return;
                                            }
                                            var n = parseInt(cleaned, 10);
                                            if (n < 0) {
                                                toast.error('Invalid input: please enter a whole number');
                                                setSeniority('');
                                                return;
                                            }
                                            var clamped = Math.max(0, n);
                                            setSeniority(String(clamped));
                                        }, onKeyDown: function (e) {
                                            // prevent decimal, exponent and signs
                                            if (e.key === '.' || e.key === ',' || e.key === 'e' || e.key === 'E' || e.key === '-' || e.key === '+') {
                                                toast.error('Invalid input: please enter a whole number');
                                                e.preventDefault();
                                            }
                                        }, onBlur: function () {
                                            // ensure there's always a number (default to 0)
                                            if (seniority === '')
                                                setSeniority('0');
                                        }, min: 0, step: 1 }) })] }), _jsx("div", { className: "my-4", children: _jsx(PrimaryButton, { title: "Save", classes: "bg-[#123662] text-white w-full py-2  rounded-[12px]", clickHandle: function () { return updateHandle(); } }) })] })] }));
};
export default EditProfileModal;
